import { render } from "./AccountModal.vue?vue&type=template&id=138fce2d&scoped=true&ts=true"
import script from "./AccountModal.vue?vue&type=script&lang=ts"
export * from "./AccountModal.vue?vue&type=script&lang=ts"

import "./AccountModal.vue?vue&type=style&index=0&id=138fce2d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138fce2d"]])

export default __exports__